export default __webpack_public_path__ + "static/ad-6e701d2a5c668dad0ea8c061097c67a5.svg";